import helpers from '../helpers.js';

let easyDrop = {
    init: () => {
        const drops = document.querySelectorAll('.js-easy-drop');
        let documentWidth = document.body.clientWidth - 30;
        let isDropOpen = false;
        document.body.style.setProperty("--calc-max-width", documentWidth + "px");

        const closeAllDrops = () => {
            document.removeEventListener("click", toggleDropFromDocument, true);
            document.removeEventListener("keydown", closeAllDropsFromKey, true);
            document.body.classList.remove('full-screen-mobile-overlay');
            drops.forEach((drop) => {
                drop.querySelectorAll('.drop-open').forEach((openDrop) => { openDrop.classList.remove('active') });
            });
            isDropOpen = false;
        }

        const closeAllDropsFromKey = (e) => {
            if (e.key === "Escape") {
                closeAllDrops();
            }
        }

        const closeDrop = (e) => {
            document.body.classList.remove('full-screen-mobile-overlay');
            e.target.closest('.easy-drop').querySelector('.drop-open.active').classList.remove('active');
        }

        const toggleDropFromDocument = (e) => {
            const parentContent = e.target.closest('.drop-content');
            if (!parentContent) { // If not clicking any dropcontent
                e.preventDefault(); // Prevent accidentally clicking links etc. when closing drops with click outside
                setTimeout(function () {
                    closeAllDrops(); // and then close all drops
                }, 0);
            } else if (parentContent && parentContent.querySelector('.drop-open.active')) { // if clicking an open drop
                setTimeout(function () { // wait until queue is done
                    parentContent.querySelectorAll('.drop-open.active').forEach((openDrop) => { openDrop.classList.remove('active') }); // close all drops inside open drop
                }, 0);
            }
        }

        const toggledrop = () => {
            return (e) => {
                const parentdrop = e.target.closest('.easy-drop');
                if (!e.target.classList.contains('active')) {
                    setTimeout(function () {
                        e.target.classList.add('active');
                        if (parentdrop?.classList.contains('full-mobile')) {
                            document.body.classList.add('full-screen-mobile-overlay');
                        }
                        if (parentdrop?.classList.contains('dropdown')) {
                            positionDropContent(parentdrop.querySelector(".drop-content"), parentdrop.dataset.position);
                        }
                        document.addEventListener("click", toggleDropFromDocument, true);
                        document.addEventListener("keydown", closeAllDropsFromKey, true);
                    }, 0);
                }
            }
        }

        const positionDropContent = (content, position) => {
            content.removeAttribute('style');
            const contentWidth = content.clientWidth > documentWidth ? documentWidth : content.clientWidth;
            content.style.width = contentWidth + "px";

            let rect = content.getBoundingClientRect();
            const leftPosition = parseInt(getComputedStyle(content).left, 10);
            const rightPosition = parseInt(getComputedStyle(content).right, 10);            
            const parentPosition = content.closest(".easy-drop").getBoundingClientRect();
            
            if(position === "right" && rect.left < 0) {
                content.style.right = -Math.abs(documentWidth - (rect.right + rightPosition)) + "px";
            } else if(position === "left") {
                const rightOverflow = contentWidth - (documentWidth - (rect.left - leftPosition));
                if(rightOverflow > 0)content.style.left = -Math.abs(rightOverflow) + "px";
            } else if(position === "center" && rect.left < 0) {
                const leftPercentage = 100 + ((rect.left + parentPosition.left + 15)* 100) / contentWidth;
                content.style.left = leftPercentage + "%";
            } else if(position === "center") {
                const rightOverflow = documentWidth < rect.right ? documentWidth - rect.right : 0;
                if(rightOverflow < 0) {
                    const leftPercentage = 50 + ((rightOverflow + helpers.getTranslateX(content).translateX - 30) * 100) / contentWidth;
                    content.style.left = leftPercentage + "%";
                }
            }
        }

        const repositionDrops = helpers.debounce(() => {
            documentWidth = document.body.clientWidth - 30;
            document.body.style.setProperty("--calc-max-width", documentWidth - 30 + "px");
            drops.forEach((drop) => {
                if(drop.classList.contains('dropdown')) {
                    positionDropContent(drop.querySelector('.drop-content'), drop.dataset.position);
                }
            });
        }, 100);

        if (drops) {
            drops.forEach((drop) => {
                for (let child of drop.children) {
                    if(child.classList.contains('drop-open')) {
                        child.addEventListener("click", toggledrop());
                    }
                }
                if(drop.classList.contains('dropdown')) {
                    positionDropContent(drop.querySelector('.drop-content'), drop.dataset.position);
                }
                const btnClose = drop.querySelector('.drop-close');
                if (btnClose) {
                    btnClose.addEventListener("click", closeDrop, true);
                }
            });

            window.addEventListener("resize", repositionDrops);
        }
    }
}

export default easyDrop;